import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import CustomerActionsMenu from './CustomerActionsMenu';
import { Box } from '@mui/material';
import CustomPagination from '../../../components/customPagination';
import { useGetCustomersHandler } from '../dataHandlers/getCustomersHandler';

const CustomersTable = ({ handlePaginationChange, searchQuery = {} }) => {
  const { customers, totalDocuments, isLoading } = useGetCustomersHandler({ searchQuery });

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
    },
    {
      field: 'email',
      headerName: 'Contact Info',
      flex: 1,
      renderCell: (params) => {
        const contacts = [];
        if (params.row.email) contacts.push(params.row.email);
        if (params.row.telephone) contacts.push(params.row.telephone);
        return contacts.join(' / ') || 'N/A';
      },
    },
    {
      field: 'company_id',
      headerName: 'Identifier',
      flex: 1,
    },
    {
      field: 'address',
      headerName: 'Country',
      flex: 1,
      renderCell: (params) => {
        const address = params.row.postal_address;
        if (!address) return 'N/A';
        return `${address.country}`;
      },
    },
    {
      field: 'type',
      headerName: 'Type',
      flex: 1,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.5,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return <CustomerActionsMenu customer={params.row} />;
      },
    },
  ];

  return (
    <Box>
      <DataGrid
        rows={customers}
        columns={columns}
        getRowId={(row) => row.id}
        paginationMode="server"
        rowCount={totalDocuments}
        loading={isLoading}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => {
          handlePaginationChange(model.page, model.pageSize);
        }}
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default CustomersTable;
